module.exports = __webpack_public_path__ + "static/media/yellowstone.f6160d24.png";